module.exports = __webpack_public_path__ + "static/media/volumeThree04.c3f00a5c.jpg";